import {buffers, eventChannel} from "redux-saga";
import {call, take, select, put} from "redux-saga/effects";
import {IApplicationState} from "../../index";
import {changeSettings} from "../actions";

export function getViewportDimensions(canvasWidth: number) {
    const aspectRatio = Math.max(document.body.offsetHeight / document.body.offsetWidth, 1.6);
    const canvasHeight = Math.ceil(canvasWidth * aspectRatio);

    const widthScale = document.body.offsetWidth / canvasWidth;
    const heightScale = document.body.offsetHeight > 240
        ? document.body.offsetHeight / canvasHeight
        : document.body.offsetWidth / aspectRatio / canvasHeight;
    const scaleFactor = Math.min(widthScale, heightScale);

    return {
        width: canvasWidth,
        height: canvasHeight,
        scaleFactor
    };
}

function* getCanvasDimensions() {
    const {canvasWidth} = yield select(({ settings }: IApplicationState) => ({
        canvasWidth: settings.canvas?.width || 800
    }));

    let debounceTimer = 0;

    return eventChannel(emit => {
        const changeCanvasSize = () => {
            if (debounceTimer) {
                clearTimeout(debounceTimer);
            }

            debounceTimer = window.setTimeout(() => {
                const viewportDimensions = getViewportDimensions(canvasWidth);
                emit(viewportDimensions);
            }, 100);
        };

        window.addEventListener('init', changeCanvasSize, false);
        window.addEventListener('orientationchange', changeCanvasSize, false);
        document.addEventListener('fullscreenchange', changeCanvasSize, false);
        window.addEventListener('resize', changeCanvasSize, false);

        const unsubscribe = () => {
            window.removeEventListener('init', changeCanvasSize);
            window.removeEventListener('orientationchange', changeCanvasSize);
            document.removeEventListener('fullscreenchange', changeCanvasSize, false);
            window.removeEventListener('resize', changeCanvasSize, false);
        };

        return () => {
            unsubscribe()
        };
    }, buffers.sliding(1));
}

export function* watchViewportDimensions() {
    const viewportDimensionsChannel = yield call(getCanvasDimensions);

    while (true) {
        const viewportDimensions = yield take(viewportDimensionsChannel);

        yield put(changeSettings({
            canvas: viewportDimensions
        }));
    }
}